import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DeleteButton from '../shared/buttons/DeleteButton';

const CustomerDeleteButton = ({
    customerId,
    canDelete: initialCanDelete,
    deleteFormId,
    showText
}) => {
    const [canDelete, setCanDelete] = useState(initialCanDelete);

    const canDeleteUrl = `/api/customers/CanDeleteCustomer/${customerId}`;

    const deleteItem = () => {
        const form = document.getElementById(deleteFormId);

        if (!form) {
            console.error(`Delete form '${deleteFormId}' was not found.`);
            return;
        }

        if (form.requestSubmit) {
            form.requestSubmit();
        } else {
            form.submit();
        }
    };

    const refreshCanDelete = useCallback(async () => {
        try {
            const response = await fetch(canDeleteUrl, {
                method: 'GET',
                credentials: 'same-origin'
            });

            if (!response.ok) {
                console.error(
                    `Unable to determine whether the customer can be deleted. ` +
                    `Status: ${response.status}`
                );

                setCanDelete(false);
                return;
            }

            const result = await response.json();
            setCanDelete(result === true);
        } catch (error) {
            console.error(
                'Unable to determine whether the customer can be deleted.',
                error
            );

            setCanDelete(false);
        }
    }, [canDeleteUrl]);

    useEffect(() => {
        window.addEventListener('updateChangeLog', refreshCanDelete);

        return () => {
            window.removeEventListener('updateChangeLog', refreshCanDelete);
        };
    }, [refreshCanDelete]);
    if (!canDelete) {
        return null;
    }

    return (
        <DeleteButton
            itemName="customer"
            onClick={deleteItem}
            showText={showText}
        />
    );
};

CustomerDeleteButton.propTypes = {
    customerId: PropTypes.number.isRequired,
    canDelete: PropTypes.bool,
    deleteFormId: PropTypes.string.isRequired,
    showText: PropTypes.bool
};

CustomerDeleteButton.defaultProps = {
    canDelete: false,
    showText: true
};

export default CustomerDeleteButton;